import { Request } from 'api';
import { AxiosResponse } from 'axios';

type ReturnType = Promise<AxiosResponse>;

const userLogOutFromAllDevices = (): ReturnType => {
    return Request.post(`/authentication/logout-all`);
};
export default userLogOutFromAllDevices;
